import packageMetadata from "../package.json";

export const APP_VERSION = packageMetadata.version;
